import React, { useState } from "react";
import styles from "./investorForm.module.css";
import axios from "axios";

export const InvestorForm = ({ onClose }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    country: "",
    message: "",
  });

  const [responseMessage, setResponseMessage] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Form submitted with data:", formData);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        setResponseMessage("✅ Email sent successfully!");
        setFormData({
          name: "",
          email: "",
          phone: "",
          country: "",
          message: "",
        });

        setTimeout(() => {
          setResponseMessage("");
        }, 10000);
      }
    } catch (error) {
      setResponseMessage("❌ Network error, please try again later.");
      setTimeout(() => {
        setResponseMessage("");
      }, 5000);
    }
  };

  return (
    <div className={styles.main_contactform_page}>
      <div className={styles.contactform_container}>
        <div className={styles.modal_overlay}>
          <div className={styles.modal}>
            <button className={styles.close_button} onClick={onClose}>
              ×
            </button>
            <h2>Become an Investor</h2>
            <p>Build the Future</p>
            {/* <h2>Become a Business Corners Investor</h2> */}
            <form className={styles.contact_form} onSubmit={handleSubmit}>
              <div className={styles.form_group}>
                <label htmlFor="name">Your Name</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  placeholder="Your Name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className={styles.form_group}>
                <label htmlFor="email">Your Email Address</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="Your Email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className={styles.form_group}>
                <label htmlFor="phone">Your Phone Number</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                  pattern="[0-9]{3}[0-9]{3}[0-9]{4}"
                  placeholder="1234567890"
                />
              </div>

              <div className={styles.form_group}>
                <label htmlFor="country">Your Country Name</label>
                <input
                  type="text"
                  id="country"
                  name="country"
                  placeholder="Enter Your Country"
                  value={formData.country}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className={styles.form_group}>
                <label htmlFor="message">Your Message</label>
                <textarea
                  id="message"
                  name="message"
                  placeholder="Your Message"
                  value={formData.message}
                  onChange={handleChange}
                  required></textarea>
              </div>
              {responseMessage && <p>{responseMessage}</p>}
              <button type="submit" className={styles.submit_button}>
                Send Message
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvestorForm;
